import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/blacklist-admin/list', data, {params})
  },
  save(data){
    return http.post('/api/v1/blacklist-admin', data)
  },
  get(id) {
    return http.get(`/api/v1/blacklist-admin/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/blacklist-admin/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/blacklist-admin/${id}/status`, null, {
      params: { status },
    });
  },
  delete(id) {
    return http.delete(`/api/v1/blacklist-admin/${id}`)
  }
}
